import * as account from './account';
import * as event from './event';
import { createSelector } from 'reselect';
import { map } from 'lodash';
import { getIn } from 'icepick';

export function getSelectedMerchantAccount(state) {
  return account.getSelectedMerchantAccount(state.account, event.getSelectedMerchantAccountId(state.event));
}

export function isFeesEnabled(state) {
  return event.isFeesEnabled(state.event);
}

export function isDiscountCodesEnabled(state) {
  return event.isDiscountCodesEnabled(state.event);
}

/**
 * Selector to return the flexProductVersion fetched from the state
 */
export function getFlexProductVersion(state) {
  return getIn(state, ['experimentSettings', 'flexProductVersion']) || -1;
}

export const getSpeakerCategories = createSelector(
  account.getAccountSpeakerCategories,
  state => event.getSpeakerCategoryOrder(state.event),
  (categories, orderList) => {
    return Object.keys(orderList)
      .map(categoryId => {
        return { ...categories[categoryId], ...{ order: orderList[categoryId] } };
      })
      .sort((a, b) => a.order - b.order);
  });

export const getWebsiteSpeakersWithCategories = createSelector(
  state => event.getWebsiteSpeakers(state.event),
  getSpeakerCategories,
  (speakers, speakerCategories) => {
    return map(speakers, speaker => {
      const category = speakerCategories.find(speakerCategory => speakerCategory.id === speaker.categoryId);
      const categoryName = category ? category.name : null;
      return {
        ...speaker,
        category: categoryName
      };
    });
  });
